import { useTranslation, FAIcon, IconStyle } from '@nextgen-web-framework/all';
import LanguageModal from '../LanguageModal/LanguageModal';
import useLanguageSelector from '../../utils/useLanguageSelector';
import { FooterLanguageProps } from './types/propTypes';
import styles from './FooterLanguage.module.scss';
const FooterLanguage = ({ locale, langHandler }: FooterLanguageProps) => {
  const { showLanguageModal, onCloseHandler, languageClickHandler, handleLanguageChange } = useLanguageSelector({
    langHandler,
  });
  const t = useTranslation();

  return (
    <div className={styles['footer-language-container']} data-testid="footer-language-container-test-id">
      <div className={styles['footer-language-dropdown']}>
        <span className={styles['language-title']}>{t('web.lang')}</span>
        <div>
          <FAIcon
            className={styles['sort-down-icon']}
            iconName={'sort-down'}
            iconStyle={IconStyle.SOLID}
            data-testid="sort-down-test-id"
            onClick={languageClickHandler}
          />
        </div>
        {showLanguageModal && (
          <LanguageModal languageHandler={handleLanguageChange} currentLocale={locale} onClose={onCloseHandler} />
        )}
      </div>
    </div>
  );
};

export default FooterLanguage;
